import ColumnSet from '@/components/grid/columns/column-set';
import ColumnDefinition from '@/common/definitions/columns/customers';

export default new ColumnSet({
    id: 'customers-list',
    ...ColumnDefinition,
});
